var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-dropdown"},[(_vm.value)?_c('div',{staticClass:"overlay",on:{"click":_vm.toggleDropdown}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.value)?_c('div',{staticClass:"t-dropdown-menu",style:(_vm.passedStyle)},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }